import { useQuery, QueryFunction, QueryKey, UseQueryOptions } from 'react-query'

import { ApiErrorBase } from 'api/core/ApiErrorBase'

import { useOnApiError } from './useOnApiError'

export type QueryOptions<
  TQueryFnData = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = Omit<UseQueryOptions<TQueryFnData, ApiErrorBase, TData, TQueryKey>, 'queryKey' | 'queryFn'>

/**
 * Override default query onError functions to catch the unauthorized errors and refresh the session
 */
export function useApiQuery<
  TQueryFnData = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: QueryOptions<TQueryFnData, TData, TQueryKey>,
) {
  return useQuery<TQueryFnData, ApiErrorBase, TData, TQueryKey>(queryKey, queryFn, {
    ...options,
    onError: useOnApiError(options?.onError),
  })
}
